import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=263e1662&scoped=true"
import script from "./Pic.vue?vue&type=script&lang=js"
export * from "./Pic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e1662",
  null
  
)

export default component.exports